const initialState = {
  ledgerData: [],
  loading: false,
  error: null
};

const InvoiceLedgerReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'FETCH_INVOICE_LEDGER_REQUEST':
      return { ...state, loading: true, error: null };

    case 'FETCH_INVOICE_LEDGER_SUCCESS':
      return { 
        ...state, 
        loading: false, 
        ledgerData: action.payload, 
        error: null 
      };

    case 'FETCH_INVOICE_LEDGER_FAILURE':
      return { ...state, loading: false, error: action.payload };

    case 'CLEAR_INVOICE_LEDGER':
      return { ...state, ledgerData: [], error: null };

    default:
      return state;
  }
};

export default InvoiceLedgerReducer;